import { createActions } from 'redux-actions';

const actions = createActions({
  APPLICATION_MESSAGES_LOADED: (data) => data,
  CLEAR_ALL_CUSTOMER_CACHE: () => { },
  CLEAR_USER_CACHE: () => { },
  CONTENTFUL_PAGE_LOADED: (data) => data,
  DIALOG_MESSAGE_UPDATED: (data) => data,
  GENERAL_DATA_LOADED: (data) => data,
  GET_CONTENTFUL_PAGE: (data) => data,
  GET_GENERAL_DATA: () => { },
  GET_LANGUAGES: () => { },
  GET_PUBLIC_SIDE_IMAGE: () => { },
  GET_SHARE_POST_DATA: (data) => data,
  GET_SHARE_POST_DATA_FAILED: () => { },
  GET_SHARE_POST_DATA_SUCCESS: (data) => data,
  GLOBAL_CONTACT_US_MODAL_TOGGLED: (data) => data,
  LANGUAGES_LOADED_FAILED: () => { },
  LANGUAGES_LOADED_SUCCESS: (data) => data,
  LINK_MESSAGE_SENT: (data) => (data),
  LOGOUT_MODAL_VISIBLE_CHANGED: (data) => data,
  PUBLIC_SIDE_IMAGE_LOADED: (data) => (data),
  SAVE_LANGUAGE_PREFERENCE: (data) => data,
  SEND_LINK_MESSAGE: (data) => (data),
  SEND_MESSAGE_RESTARTED: () => ({}),
  SHOW_GENERIC_ERROR: (data) => data,
  SWITCHING_LANGUAGE_CHANGED: (data) => data,
});

export const {
  applicationMessagesLoaded,
  clearAllCustomerCache,
  clearUserCache,
  contentfulPageLoaded,
  dialogMessageUpdated,
  generalDataLoaded,
  getContentfulPage,
  getGeneralData,
  getLanguages,
  getPublicSideImage,
  getSharePostData,
  getSharePostDataFailed,
  getSharePostDataSuccess,
  globalContactUsModalToggled,
  languagesLoadedFailed,
  languagesLoadedSuccess,
  linkMessageSent,
  logoutModalVisibleChanged,
  publicSideImageLoaded,
  saveLanguagePreference,
  sendLinkMessage,
  sendMessageRestarted,
  showGenericError,
  switchingLanguageChanged,
} = actions;
